export function useListContextValues_unstable(state) {
    const { navigable, selection, as, truncateContent, truncateHeader } = state;
    const listContext = {
        navigable,
        selection,
        as,
        truncateContent,
        truncateHeader
    };
    return {
        listContext
    };
}
